module.exports = __webpack_public_path__ + "img/digitization-total-trafic.f5340a21.svg";